import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["appearance", "isOpen", "testId", "text", "triggerRef"];
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { useCallback, useMemo, useState } from 'react';
import Lozenge from '@atlaskit/lozenge';
import ChevronDownIcon from '@atlaskit/icon/glyph/chevron-down';
import { triggerButtonStyles, triggerLozengeStyles } from '../styled';
var LozengeActionTrigger = function LozengeActionTrigger(_ref) {
  var appearance = _ref.appearance,
    isOpen = _ref.isOpen,
    testId = _ref.testId,
    text = _ref.text,
    triggerRef = _ref.triggerRef,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isBold = _useState2[0],
    setIsBold = _useState2[1];
  var onMouseEnter = useCallback(function () {
    return setIsBold(true);
  }, []);
  var onMouseLeave = useCallback(function () {
    return setIsBold(false);
  }, []);
  var lozenge = useMemo(function () {
    return jsx(Lozenge, {
      appearance: appearance,
      isBold: isBold
    }, jsx("span", {
      css: triggerLozengeStyles
    }, jsx("span", null, text), jsx(ChevronDownIcon, {
      label: "options",
      size: "medium"
    })));
  }, [appearance, isBold, text]);
  return jsx("button", _extends({
    type: "button"
  }, props, {
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    css: triggerButtonStyles,
    "data-action-open": isOpen,
    "data-testid": "".concat(testId, "--trigger"),
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    ref: triggerRef
  }), lozenge);
};
export default LozengeActionTrigger;